export default __webpack_public_path__ + "static/bussines-own-428622fc7fbff059abdb8f48791c70ae.png";